export default {
      id: "ArrowRightTrimmed-usage",
      viewBox: "0 0 5 8",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#ArrowRightTrimmed",
      toString: function () {
        return this.url;
      }
    }